import React from 'react';
import { MapPin } from 'lucide-react';

export const LocationChip = () => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.45rem',
      padding: '0.4rem 0.9rem',
      border: '1px solid rgba(197,160,89,0.45)',
      borderRadius: '999px',
      color: 'var(--accent-gold)',
      fontSize: '0.78rem',
      fontWeight: 600,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      marginBottom: '1.5rem',
      backdropFilter: 'blur(8px)',
      background: 'rgba(197,160,89,0.06)'
    }}
  >
    <MapPin size={14} /> Serving Chandannagar · Chinsurah · Hooghly
  </div>
);
